<template>
    <div id="not-found-page">
        <div class="container h-100">
            <div class="row h-100">
                <div class="col-12 h-100 pt-5 pb-10 d-flex flex-column align-items-center justify-content-center">
                    <div class="ghost">
                        <div class="hidden"><i class="fas fa-ghost"></i></div>
                        <span class="icon"><i class="fas fa-ghost"></i></span>
                    </div>
                    <h1 class="title">Not Found</h1>
                    <p class="text">The page you requested was not found.</p>
                    <router-link class="go-home" to="/"><i class="fas fa-home"></i>Go Home</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "sign-up-page",
    components: {
        // 
    },
}
</script>
